<kendo-textbox-container [formGroup]="form" class="w-100" [floatingLabel]="label">

  <input type="text" kendoTextBox [formControlName]="name">

  <small class="alert-danger mt-1"  *ngIf="form.get(name).touched && form.get(name).errors && form.get(name).dirty">
    {{form.get(name).hasError('required') ? 'Ce champ est requis' : ''}}
  </small>
</kendo-textbox-container>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/shared/form/input-text/input-text.component.html